
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import { Observer } from 'mobx-vue'
import Dots from './Dots.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { ClickEvent } from '@xt/client/types/home.d'

@Observer
@Component({
  components: {
    NewSwiper,
    Dots,
    LazyImg
  }
})
export default class ModelBanner extends Vue {
  @Prop() dataSource: Array<{ cover: string; event?: ClickEvent }>

  @Ref()
  swiper: {
    dotScrollTo: (index: number) => void
  }

  activeIndex: number = 0
  autoplayDuration: number = 3000

  @Emit('handle-click')
  handleClick(item) {
    return item
  }

  // 指示点滚动事件
  handleScrollTo(index: number) {
    if (!this.swiper) return
    this.swiper.dotScrollTo(index)
  }

  // 轮播切换事件
  handleChange(index: number) {
    if (this.activeIndex === index) return

    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
